export default {
  saveId({ commit }, status) {
    commit('SAVE_ID', status)
  },
  saveStatus({ commit }, status) {
    commit('SAVE_STATUS', status)
  },
}
